module.exports = __webpack_public_path__ + "img/logo_标准@2x.77ead7e7.png";